import { __spreadArray, __read } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { formatCurrency, pluralizeDays, pluralizePeriod } from '../../../../helpers/fomatters.js';
import { OfferCard } from '../../OfferCard.js';
import '@sravni/react-design-system';
import '@sravni/react-design-system/lib/Typography';
import '../../components/WithIcon/WithIcon.module.scss.js';
import 'classnames';
import '../../components/CardIcon/CardIcon.module.scss.js';
import '@sravni/react-icons';
import '../../components/Rating/Rating.module.scss.js';
import '../../components/CardTitle/CardTitle.module.scss.js';
import { OfferParam } from '../../components/OfferParam/OfferParam.js';
import '../../components/OfferParams/OfferParams.module.scss.js';
import { CreditCardSubtitle } from '../../components/Subtitles/Subtitles.js';
import 'react';
import '../../components/Notifications/Notifications.module.scss.js';

var CardCreditCard = function (_a) {
    var bankName = _a.bankName, bankIcon = _a.bankIcon, badges = _a.badges, limit = _a.limit, partialPaymentsPeriod = _a.partialPaymentsPeriod, fee = _a.fee, gracePeriodInDays = _a.gracePeriodInDays, controls = _a.controls, onClick = _a.onClick, rating = _a.rating, reviews = _a.reviews;
    var productsSummary = __spreadArray([
        jsx(OfferParam, { label: "\u041B\u0438\u043C\u0438\u0442", value: "\u0434\u043E ".concat(formatCurrency(limit)) }, "limit"),
        jsx(OfferParam, { label: "\u041B\u044C\u0433\u043E\u0442\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434", value: "\u0434\u043E ".concat(gracePeriodInDays, " ").concat(pluralizeDays(gracePeriodInDays)) }, "gracePeriod"),
        jsx(OfferParam, { label: "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435", value: fee ? "".concat(formatCurrency(fee), " \u0432 \u0433\u043E\u0434") : 'Бесплатно' }, "fee")
    ], __read((partialPaymentsPeriod
        ? [
            jsx(OfferParam, { label: "\u0420\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0430", value: "\u0434\u043E ".concat(pluralizePeriod(partialPaymentsPeriod, true)) }, "partialPaymentsPeriod"),
        ]
        : [])), false);
    return (jsx(OfferCard, { title: bankName, icon: bankIcon, badges: badges, controls: controls, subtitle: jsx(CreditCardSubtitle, {}), onClick: onClick, summary: productsSummary, rating: rating, reviews: reviews }));
};

export { CardCreditCard };
//# sourceMappingURL=CardCreditCard.js.map
